'use client';

import { createContext, ReactNode, useContext } from 'react';

import { SiteSetting } from '@/types';

interface SiteSettingsContextType {
  siteSettings: SiteSetting | null;
}

const SiteSettingsContext = createContext<SiteSettingsContextType | undefined>(undefined);

interface SiteSettingsProviderProps {
  children: ReactNode;
  siteSettings: SiteSetting | null;
}

export function SiteSettingsProvider({ children, siteSettings }: SiteSettingsProviderProps) {
  return (
    <SiteSettingsContext.Provider value={{ siteSettings }}>{children}</SiteSettingsContext.Provider>
  );
}

export function useSiteSettings() {
  const context = useContext(SiteSettingsContext);
  if (context === undefined) {
    throw new Error('useSiteSettings must be used within a SiteSettingsProvider');
  }
  return context;
}
